import { serviceMaker, methods, api } from "@/http/index.js";

export const getManageCodesData = () =>
  serviceMaker(`/codes`, methods.GET, api.NGB);
export const createcodes = (data) =>
  serviceMaker(`/codes`, methods.POST, api.NGB, data);
export const dataByIdCodes = (id) =>
  serviceMaker(`/codes/${id}`, methods.GET, api.NGB);
export const dataByIdcodevalues = (id) =>
  serviceMaker(`/codes/${id}/codevalues`, methods.GET, api.NGB);
export const createCodevalues = (id, data) =>
  serviceMaker(`/codes/${id}/codevalues`, methods.POST, api.NGB, data);
export const deleteManageCodesData = (id) =>
  serviceMaker(`/codes/${id}`, methods.DELETE, api.NGB);
export const deleteCodeValues = (id, CodeValuesid) =>
  serviceMaker(
    `/codes/${id}/codevalues/${CodeValuesid}`,
    methods.DELETE,
    api.NGB
  );
